import { getTierFeatures } from '../lib/contestTiersConfig';
import { CollaborationMethod } from '../types';
import type { ZendeskLanguage } from '@99designs/routing';
import type { ComparativeProduct, ContestProduct } from '../types';

export function useContestTiersConfig(
    products: ContestProduct[],
    lang: ZendeskLanguage
): ComparativeProduct[] {
    if (!products) return [];
    return products.map((product: ContestProduct) => {
        const features = getTierFeatures(product.tier, product.category, lang);

        return {
            ...product,
            collaborationMethod: CollaborationMethod.Contest,
            features,
        };
    });
}
